import React from "react";
import { INPUT_BASE, LABEL_TEXT } from "../styles/classNames";

/**
 * Универсальный компонент для input полей
 */
export function FormInput({ label, value, onChange, placeholder, type = "text", disabled = false }) {
  return (
    <label className="block">
      <div className={LABEL_TEXT}>{label}</div>
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        className={INPUT_BASE}
      />
    </label>
  );
}
